import { render, staticRenderFns } from "./AppPagination.vue?vue&type=template&id=057551ca&scoped=true&"
import script from "./AppPagination.vue?vue&type=script&lang=js&"
export * from "./AppPagination.vue?vue&type=script&lang=js&"
import style0 from "./AppPagination.vue?vue&type=style&index=0&id=057551ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057551ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('057551ca')) {
      api.createRecord('057551ca', component.options)
    } else {
      api.reload('057551ca', component.options)
    }
    module.hot.accept("./AppPagination.vue?vue&type=template&id=057551ca&scoped=true&", function () {
      api.rerender('057551ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppPagination.vue"
export default component.exports